// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__XazTx","heart":"Footer_heart__3_LfB","pound":"Footer_pound__1oPlA"};